// extracted by mini-css-extract-plugin
export default {"root":"IconCardDashboard_root__PWV10"};